/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
/* eslint-disable react/jsx-sort-props */
import Spinner from '@atlaskit/spinner';
import React, { FC, useEffect, useState } from 'react';

import {
    Icon,
    IconAddCircle,
    IconCloseSched,
    IconRemove
} from '../../../base/icons';

interface CreateGroupProps {
    onClose: Function,
    onSave: Function,
    isOpen: boolean,
    addContactList: Array,
    isOpenAddContactPopup: boolean,
    isOpenAddExistedPopup: boolean,
    openAddExistedContactsModal: Function
}

const CreateGroup: FC<CreateGroupProps> = (props) => {
    const { onClose, onSave, isOpen, addContactList, removeAddContactItem, isOpenAddContactPopup, openAddExistedContactsModal, isOpenAddExistedPopup } = props;
    const [ inputLabel, setInputLabel ] = useState('');
    const [ isLoading, setIsLoading ] = useState(false);
    const [ errors, setErrors ] = useState({
        groupName: undefined,
        members: undefined
    });
    const renderItems = () => addContactList.map((item, index) => (
        <div
            className = { 'o-create-group-content-label-list' }
            key = { index }>
            <p>{item.name} {item.lastName || item.subName}</p>
            <div
                className = { 'o-create-group-content-label-list--remove' }
                onClick = { () => removeAddContactItem(index, item) }>
                <Icon
                    size = { 20 }
                    src = { IconRemove } />
            </div>
        </div>
    ));

    const handleSetErrors = (name, value) => {
        setErrors({
            ...errors,
            [name]: value
        });
    };

    const handleSave = () => {
        const newErrors = {};

        if (inputLabel.length > 30) {
            newErrors.groupName = 'Maximum length is 30 characters !';
        }
        if (!inputLabel.trim()) {
            newErrors.groupName = 'Please add the group name!';
        }
        if (!addContactList.length) {
            newErrors.members = 'Please add the group member!';
        }
        setErrors(newErrors);

        if (Object.keys(newErrors).find(key => newErrors[key])) {
            return;
        }

        try {
            setIsLoading(true);
            onSave({
                name: inputLabel,
                contactIds: addContactList.map(item => item?.id)
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = value => {
        setInputLabel(value);
        handleSetErrors('groupName');
    };

    useEffect(() => {
        if (addContactList) {
            setErrors({});
        }
    }, [ addContactList ]);

    return (
        !isOpenAddContactPopup && isOpen && <div className = { `o-create-group__wrapper ${isOpenAddExistedPopup ? 'disabled-background' : ''} ` }>
            <div className = 'o-create-group__background' />
            <div className = { 'o-create-group__container' }>
                <div className = { 'o-create-group' }>
                    <Icon
                        className = { 'o-create-group-close' }
                        onClick = { onClose }
                        size = { 30 }
                        src = { IconCloseSched } />
                    <div className = { 'o-create-group-title' }>
                        <p>Create Group</p>
                    </div>
                    <div className = { 'o-create-group-content' }>
                        <div className = { 'o-create-group-content-add-label-input' }>
                            <input
                                onChange = { e => handleChange(e.target.value) }
                                placeholder = { 'Add Label' }
                                className = { 'o-create-group-content-add-label-input--child' } />
                        </div>
                        { errors.groupName ? <p className = { 'o-create-group-content-error-message ' }>{errors.groupName}</p> : null }
                        <div className = { 'o-create-group-content--list-items' }>
                            {renderItems()}
                        </div>
                        <div className = { 'o-create-group-content-add-label' }>
                            <p>Add Contact</p>
                            <div
                                className = { 'o-create-group-content-add-label--add' }
                                onClick = { () => {
                                    openAddExistedContactsModal();
                                } }>
                                <Icon
                                    size = { 30 }
                                    src = { IconAddCircle } />
                            </div>
                        </div>
                        { errors.members ? <p className = { 'o-create-group-content-error-message ' }>{errors.members}</p> : null }
                    </div>
                    <div className = { 'o-create-group-tools' }>
                        <div
                            className = { 'o-create-group-tools-close' }
                            onClick = { onClose }>
                            <p>Cancel</p>
                        </div>
                        <div
                            className = { 'o-create-group-tools-save' }
                            onClick = { handleSave }>
                            {isLoading ? <Spinner /> : <p>Save</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

CreateGroup.defaultProps = {
    onClose: () => {},
    onSave: () => {},
    openAddExistedContactsModal: () => {},
    isOpen: false,
    addContactList: [],
    isOpenAddContactPopup: false
};
export default CreateGroup;
